module.exports = __webpack_public_path__ + "assets/img/filter.69e174af.svg";